var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Spinner',{attrs:{"is-loading":!_vm.isMapLoaded}}),_c('div',{attrs:{"id":"map"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }